import { NotificationFrequency } from '@partnerconnect-monorepo/types/notification/Notification';
import { t } from '@transifex/native';

export const NotificationFrequencyLabel: Record<NotificationFrequency, string> =
  {
    trigger: t('Trigger'),
    weekly: t('Weekly summary')
  };

export enum NotificationCode {
  ReportReadyForWfpApproval = 'report_ready_for_wfp_approval',
  ReportReadyForPartnerApproval = 'report_ready_for_partner_approval',
  AdHocDeleted = 'ad_hoc_deleted',
  ReportApproved = 'report_approved',
  NewMonthReportReminder = 'new_month_report_reminder',
  ReportSentBackByWfp = 'report_sent_back_by_wfp',
  ReportSentBackByPartner = 'report_sent_back_by_partner',
  ReportReadyForWfpVerification = 'report_ready_for_wfp_verification',
  ReportsPendingApproval = 'reports_pending_approval',
  ReportsPendingVerification = 'reports_pending_verification',

  // FLA
  PartnershipOpportunityCreated = 'partnership_opportunity_created',
  FlaExpiring = 'fla_expiring',
  DraftPartnerReviewed = 'draft_partner_reviewed',
  DraftWfpReviewedSendBack = 'draft_wfp_reviewed_send_back',
  FinalFlaSentBack = 'final_fla_sent_back',
  FinalFlaFinalized = 'final_fla_finalized',
  FinalFlaApproved = 'final_fla_approved',
  FinalFlaSigned = 'final_fla_signed'
}

export const NOTIFICATION_LABEL: Record<string, string> = {
  [NotificationCode.ReportReadyForWfpApproval]: t(
    'Monthly distribution report is ready for approval'
  ),
  [NotificationCode.ReportReadyForPartnerApproval]: t(
    'Monthly distribution report has been submitted by partner editor'
  ),
  [NotificationCode.AdHocDeleted]: t(
    'Daily submission has been deleted by editor'
  ),
  [NotificationCode.ReportApproved]: t(
    'Monthly distribution report has been approved'
  ),
  [NotificationCode.NewMonthReportReminder]: t(
    'Monthly distribution report is ready for submission'
  ),
  [NotificationCode.ReportSentBackByWfp]: t(
    'Monthly distribution report has been sent back by WFP approver'
  ),
  [NotificationCode.ReportSentBackByPartner]: t(
    'Monthly distribution report has been sent back by partner approver'
  ),
  [NotificationCode.ReportReadyForWfpVerification]: t(
    'Monthly distribution report has been submitted by partner approver'
  ),
  [NotificationCode.ReportsPendingApproval]: t(
    'Monthly distribution reports are pending approval'
  ),
  [NotificationCode.ReportsPendingVerification]: t(
    'Monthly distribution reports are pending verification'
  ),

  // FLA
  [NotificationCode.PartnershipOpportunityCreated]: t(
    'Partnership opportunity was created'
  ),
  [NotificationCode.FlaExpiring]: t('FLA is expiring shortly'),
  [NotificationCode.DraftPartnerReviewed]: t(
    'Reviewed partnership opportunity was received from partner'
  ),
  [NotificationCode.DraftWfpReviewedSendBack]: t(
    'Reviewed partnership opportunity was received from WFP'
  ),
  [NotificationCode.FinalFlaSentBack]: t('Final FLA was not approved'),
  [NotificationCode.FinalFlaFinalized]: t('Final FLA was sent for approval'),
  [NotificationCode.FinalFlaApproved]: t('Final FLA was approved'),
  [NotificationCode.FinalFlaSigned]: t('Final FLA was signed')
};
